export default function Footer() {
  return (
    <footer className="bg-[#3D2817] text-[#F5F1E8] py-8">
      <div className="max-w-[1600px] mx-auto px-8">
        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#F5F1E8]/60 text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
            © 2026 · Direitos reservados a Eliane da Silva Moraes
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            className="text-[#F5F1E8]/60 hover:text-[#B8860B] transition-colors text-sm cursor-pointer"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Site Oficial
          </a>
        </div>
      </div>
    </footer>
  );
}
